import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  LEVEL,
} from './constants';

function* storeLevel(data = {}, merge = true) {
  yield put({
    type: LEVEL.update,
    data,
    merge,
  });
}

function* fetchLevel({
  data,
}) {
  yield* storeLevel(data);
}

function* updateLevel({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'level',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeLevel({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'level',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      yield* storeLevel({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess);
  } catch (error) {
    yield* storeLevel();
    errorHandler('Thất bại', error);
  }
}

function* removeLevel({
  _id,
}) {
  const {
    level,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'level',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(level?.data);
    delete newData[_id];
    yield* storeLevel(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeLevel();
    errorHandler('Thất bại', error);
  }
}

function* importLevel({
  data = [],
}) {
  const {
    level,
  } = yield select();
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'level',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const newData = cloneDeep(level.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeLevel(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* LevelSaga() {
  yield all([
    yield takeEvery(LEVEL.handlers.fetch, fetchLevel),
    yield takeEvery(LEVEL.handlers.update, updateLevel),
    yield takeEvery(LEVEL.handlers.import, importLevel),
    yield takeEvery(LEVEL.handlers.remove, removeLevel),
  ]);
}
